import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPaginationModule } from "ngx-pagination";
import { AgmCoreModule } from '@agm/core';
import { ToastrModule } from 'ngx-toastr';
import { TextMaskModule } from 'angular2-text-mask';
import { ClipboardModule } from 'ngx-clipboard';
import { registerLocaleData } from "@angular/common";
import localeId from "@angular/common/locales/id";
registerLocaleData(localeId, "id");

import { AppComponent } from "./app.component";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { HomeComponent } from "./home/home.component";
import { CounterComponent } from "./counter/counter.component";
import { FetchDataComponent } from "./fetch-data/fetch-data.component";
import { LoginDialogComponent } from "./login-dialog/login-dialog.component";
import { RegisterComponent } from "./register/register.component";
import { PrincipalService } from "./services/principal.service";
import { BaseService } from "./services/base.service";
import { AuthenticationService } from "./services/authentication.service";
import { AuthorizationGuard } from "./services/authorization.guard";
import { AppRoutingModule } from "./app.routing";
import { AdminHeaderComponent } from "./layouts/admin-header/admin-header.component";
import { AdminSidebarComponent } from "./layouts/admin-sidebar/admin-sidebar.component";
import { AdminFooterComponent } from "./layouts/admin-footer/admin-footer.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ProductService } from "./services/product.service";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ListCartComponent } from "./cart/list-cart/list-cart.component";
import { ListTransactionComponent } from "./transaction/list-transaction/list-transaction.component";
import { SelectPaymentComponent } from "./transaction/select-payment/select-payment.component";
import { PaymentProofComponent } from "./transaction/payment-proof/payment-proof.component";
import { ListProductComponent } from "./product/list-product/list-product.component";
import { DetailProductComponent } from "./product/detail-product/detail-product.component";
import { ProductSuccessAddComponent } from "./product/product-success-add/product-success-add.component";
import { CartService } from "./services/cart.service";
import { ProductItemComponent } from "./product/product-item/product-item.component";
import { LoaderInterceptorService } from "./services/loader-interceptor.service";
import { ProductRekananFilterComponent } from "./product/product-rekanan-filter/product-rekanan-filter.component";
import { GlobalLoaderComponent } from "./global-loader/global-loader.component";
import { TransactionService } from "./services/transaction.service";
import { DatePipe, AsyncPipe } from "@angular/common";
import { TransactionDetailComponent } from "./transaction/transaction-detail/transaction-detail.component";
import { TransactionDetailGtComponent } from "./transaction/transaction-detail-gt/transaction-detail-gt.component";
import { SearchFilterComponent } from "./product/search-filter/search-filter.component";
import { TherapeuticService } from "./services/therapeutic.service";
import { CheckoutComponent } from "./cart/checkout/checkout.component";
import { CheckoutGtComponent } from "./cart/checkout-gt/checkout-gt.component";
import { ListNotificationComponent } from "./notification/list-notification/list-notification.component";
import { NotificationService } from "./services/notification.service";
import { TermsService } from "./services/terms.service";
import { ListPrincipalComponent } from "./principal/list-principal/list-principal.component";
import { AlertComponent } from "./alert/alert.component";
import { AlertTOPComponent } from "./alert-top/alert-top.component";
import { ListAddressComponent } from "./address/list-address/list-address.component";
import { AddProductComponent } from "./product/add-product/add-product.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { SubmitActivationComponent } from "./activation/submit-activation/submit-activation.component";
import { WaitActivationComponent } from "./activation/wait-activation/wait-activation.component";
import { HelpComponent } from "./help/help.component";
import { HelpService } from "./services/help.service";
import { InputLimitComponent } from "./pin-limit/shared/input-limit/input-limit.component";
import { InputPinComponent } from "./pin-limit/shared/input-pin/input-pin.component";
import { SetPinLimitComponent } from "./pin-limit/set-pin-limit/set-pin-limit.component";
import { PromoService } from "./services/promo.service";
import { ListPromoComponent } from "./promo/list-promo/list-promo.component";
import { DetailPromoComponent } from "./promo/detail-promo/detail-promo.component";
import { ChangeLimitComponent } from "./pin-limit/change-limit/change-limit.component";
import { ChangePinComponent } from "./pin-limit/change-pin/change-pin.component";
import { ReceivableService } from "./services/receivable.service";
import { ListReceivableComponent } from "./receivable/list-receivable/list-receivable.component";
import { ProductSuccessUploadComponent } from "./product/product-success-upload/product-success-upload.component";
import { DownloadIosComponent } from "./download-ios/download-ios.component";
import { PaymentChannelComponent } from "./receivable/payment-channel/payment-channel.component";
import { OtherPaymentChannelComponent } from "./receivable/other-payment-channel/other-payment-channel.component";
import { ProcessPaymentComponent } from "./receivable/process-payment/process-payment.component";
import { DetailPaymentComponent } from "./receivable/detail-payment/detail-payment.component";
import { PaymentService } from "./services/payment.service";
import { PointService } from "./services/point.service";
import { ListVoucherComponent } from "./point/list-voucher/list-voucher.component";
import { DetailVoucherComponent } from "./point/detail-voucher/detail-voucher.component";
import { HistoryPointComponent } from "./point/history-point/history-point.component";
import { RewardComponent } from "./point/reward/reward.component";
import { RedeemPopupComponent } from "./point/redeem-popup/redeem-popup.component";
import { MapMarkerDialogComponent } from "./register/shared/map-marker-dialog/map-marker-dialog.component";
import { RegisterBusinessFormComponent } from "./register/shared/register-business-form/register-business-form.component";
import { RegisterCallCenterDialogComponent } from "./register/shared/register-call-center-dialog/register-call-center-dialog.component";
import { RegisterInformationDialogComponent } from "./register/shared/register-information-dialog/register-information-dialog.component";
import { RegisterTncDialogComponent } from "./register/shared/register-tnc-dialog/register-tnc-dialog.component";
import { RegisterTaxpayerFormComponent } from "./register/shared/register-taxpayer-form/register-taxpayer-form.component";
import { RegisterUserFormComponent } from "./register/shared/register-user-form/register-user-form.component";
import { SurveyService } from "./services/survey.service";
import { ListProgramComponent } from "./program/list-program/list-program.component";
import { DetailProgramComponent } from "./program/detail-program/detail-program.component";
import { ProgramService } from "./services/program.service";
import { TrackingB2bComponent } from "./ezrx-b2b/tracking-b2b/tracking-b2b.component";
import { TrackingB2bService } from "./services/tracking-b2b.service";
import { StockSimulationComponent } from "./ezrx-b2b/stock-simulation/stock-simulation.component";
import { StockSimulationService } from "./services/stock-simulation.service";
import { MasterService } from "./services/master.service";
import { RegistrationGuard } from "./services/registration.guard";
import { RegistrationService } from "./services/registration.service";
import { DetailPoolOrderComponent } from './transaction/detail-pool-order/detail-pool-order.component';
import { DetailHargaComponent } from './detail-harga/detail-harga.component';
import { DetailArtikelComponent } from './detail-artikel/detail-artikel.component';
import { ArticleService } from "./services/article.service";
import { ArticleComponent } from './article/article.component';
import { ListReturComponent } from './receivable/list-retur/list-retur.component';
import { ListProposalComponent } from './proposal/list-proposal/list-proposal.component';
import { DetailProposalComponent } from './proposal/detail-proposal/detail-proposal.component';
import { ProposalService } from './services/proposal.service';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { AngularFireAuthModule } from 'angularfire2/auth';
// import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
// import { MessagingService } from './services/messaging.service';
// import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { ArticleFilterBoxComponent } from './article-components/article-filter-box/article-filter-box.component';

import { PaymentChannelsResolver } from './resolvers/payment-channels.resolver';
import { PaymentGuideResolver } from './resolvers/payment-guide.resolver';
import { PopupMessagePaymentResolver } from './resolvers/popup-message-payment.resolver';
import { PopupMessagePaymentProofResolver } from './resolvers/popup-message-payment-proof.resolver';
import { PopupMessageCancelTransactionResolver } from './resolvers/popup-message-cancel-transaction.resolver';
import { PopupMessageReminderTransactionResolver } from './resolvers/popup-message-reminder-transaction.resolver';
import { PopupMessageRegistrationResolver } from './resolvers/popup-message-registration.resolver';
import { PopupMessageRegistrationNPWPResolver } from './resolvers/popup-message-registration-npwp.resolver';
import { PopupMessageRegistrationSuccessResolver } from './resolvers/popup-message-registration-success.resolver';
import { RegistrationResolver } from './resolvers/registration.resolver';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    FetchDataComponent,
    LoginDialogComponent,
    RegisterComponent,
    AdminHeaderComponent,
    AdminSidebarComponent,
    AdminFooterComponent,
    DashboardComponent,
    ResetPasswordComponent,
    ListCartComponent,
    ListTransactionComponent,
    SelectPaymentComponent,
    PaymentProofComponent,
    TransactionDetailComponent,
    TransactionDetailGtComponent,
    ListProductComponent,
    DetailProductComponent,
    ProductSuccessAddComponent,
    ProductItemComponent,
    ListNotificationComponent,
    ProductRekananFilterComponent,
    GlobalLoaderComponent,
    ListPrincipalComponent,
    SearchFilterComponent,
    CheckoutComponent,
    CheckoutGtComponent,
    AlertComponent,
    AlertTOPComponent,
    ListAddressComponent,
    AddProductComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    SubmitActivationComponent,
    WaitActivationComponent,
    HelpComponent,
    InputLimitComponent,
    InputPinComponent,
    SetPinLimitComponent,
    ListPromoComponent,
    DetailPromoComponent,
    ChangeLimitComponent,
    ChangePinComponent,
    ListReceivableComponent,
    ProductSuccessUploadComponent,
    DownloadIosComponent,
    PaymentChannelComponent,
    OtherPaymentChannelComponent,
    ProcessPaymentComponent,
    DetailPaymentComponent,
    ListVoucherComponent,
    DetailVoucherComponent,
    HistoryPointComponent,
    RewardComponent,
    RedeemPopupComponent,
    ListProgramComponent,
    DetailProgramComponent,
    TrackingB2bComponent,
    StockSimulationComponent,
    MapMarkerDialogComponent,
    RegisterBusinessFormComponent,
    RegisterCallCenterDialogComponent,
    RegisterInformationDialogComponent,
    RegisterTncDialogComponent,
    RegisterTaxpayerFormComponent,
    RegisterUserFormComponent,
    DetailPoolOrderComponent,
    DetailHargaComponent,
    DetailArtikelComponent,
    ArticleComponent,
    ArticleFilterBoxComponent,
    ListReturComponent,
    ListProposalComponent,
    DetailProposalComponent
  ],
  entryComponents: [MapMarkerDialogComponent, RegisterCallCenterDialogComponent, RegisterInformationDialogComponent, RegisterTncDialogComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgbModule.forRoot(),
    NgxPaginationModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ['places']
    }),
    ToastrModule.forRoot(),
    TextMaskModule,
    ClipboardModule
    // AngularFireDatabaseModule,
    // AngularFireAuthModule,
    // AngularFireMessagingModule,
    // AngularFireModule.initializeApp(environment.firebaseConfig)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: "id-ID" },
    DatePipe,
    BaseService,
    PrincipalService,
    ArticleService,
    ProductService,
    CartService,
    AuthenticationService,
    AuthorizationGuard,
    TransactionService,
    TherapeuticService,
    NotificationService,
    TermsService,
    PromoService,
    HelpService,
    ReceivableService,
    PaymentService,
    PointService,
    SurveyService,
    ProgramService,
    TrackingB2bService,
    StockSimulationService,
    ProposalService,
    MasterService,
    RegistrationGuard,
    RegistrationService,
    RegistrationResolver,
    PaymentChannelsResolver,
    PaymentGuideResolver,
    PopupMessagePaymentResolver,
    PopupMessagePaymentProofResolver,
    PopupMessageCancelTransactionResolver,
    PopupMessageReminderTransactionResolver,
    PopupMessageRegistrationResolver,
    PopupMessageRegistrationNPWPResolver,
    PopupMessageRegistrationSuccessResolver,
    // MessagingService,
    // AsyncPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
